/**
 * @generated SignedSource<<e2eba3a44b073d93b861ba6be769d833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunNovaAgentDryRunInput = {
  id: string;
  taskId: string;
  message?: string | null;
  threadId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RunNovaAgentDryRunMutation$variables = {
  input: RunNovaAgentDryRunInput;
};
export type RunNovaAgentDryRunMutation$data = {
  readonly runNovaAgentDryRun: {
    readonly result: {
      readonly output: string | null;
      readonly ranAt: string | null;
      readonly run: {
        readonly threadId: string | null;
        readonly modelDisplayName: string | null;
        readonly grounding: {
          readonly resolved: ReadonlyArray<{
            readonly token: string | null;
            readonly estimatedTokens: number | null;
          }> | null;
          readonly skipped: ReadonlyArray<{
            readonly token: string | null;
            readonly input: string | null;
            readonly reason: string | null;
          }> | null;
          readonly withheld: ReadonlyArray<{
            readonly token: string | null;
            readonly reason: string | null;
          }> | null;
          readonly truncated: ReadonlyArray<{
            readonly token: string | null;
            readonly keptTokens: number | null;
            readonly estimatedTotalTokens: number | null;
          }> | null;
          readonly broken: ReadonlyArray<{
            readonly token: string | null;
            readonly input: string | null;
            readonly reason: string | null;
          }> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type RunNovaAgentDryRunMutation = {
  variables: RunNovaAgentDryRunMutation$variables;
  response: RunNovaAgentDryRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "output",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ranAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelDisplayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "input",
    "storageKey": null
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaGroundingAccount",
  "kind": "LinkedField",
  "name": "grounding",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaGroundingResolvedEntry",
      "kind": "LinkedField",
      "name": "resolved",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedTokens",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaGroundingReferenceEntry",
      "kind": "LinkedField",
      "name": "skipped",
      "plural": true,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaGroundingWithheldEntry",
      "kind": "LinkedField",
      "name": "withheld",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaGroundingTruncatedEntry",
      "kind": "LinkedField",
      "name": "truncated",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "keptTokens",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedTotalTokens",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaGroundingReferenceEntry",
      "kind": "LinkedField",
      "name": "broken",
      "plural": true,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunNovaAgentDryRunMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentDryRunPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentDryRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaDryRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunNovaAgentDryRunMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentDryRunPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentDryRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaDryRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3eccea043ad9908fa0a31fa47ae1599d",
    "id": null,
    "metadata": {},
    "name": "RunNovaAgentDryRunMutation",
    "operationKind": "mutation",
    "text": "mutation RunNovaAgentDryRunMutation(\n  $input: RunNovaAgentDryRunInput!\n) {\n  runNovaAgentDryRun(input: $input) {\n    result {\n      output\n      ranAt\n      run {\n        threadId\n        modelDisplayName\n        grounding {\n          resolved {\n            token\n            estimatedTokens\n          }\n          skipped {\n            token\n            input\n            reason\n          }\n          withheld {\n            token\n            reason\n          }\n          truncated {\n            token\n            keptTokens\n            estimatedTotalTokens\n          }\n          broken {\n            token\n            input\n            reason\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "22b095c9c875628f6835a9dcde12eacc";

export default node;
